import React from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import {AudioPlayer} from '@ey/canvascoreservices';
import styled from 'styled-components';
import {currentResource} from '../../../util/utils';

const NoteRecording = ({id, duration, engagementId, darkMode, documentServiceURL}) => {
	if (documentServiceURL === null) return null;

	const props = {
		src: documentServiceURL,
		documentId: id,
		engagementId,
		loader: <LoadingIndicator />,
		time: duration,
		discard: false,
		darkMode: false,
		playButtonTitle: currentResource.reviewNoteLabels.playButtonTitle,
		pauseButtonTitle: currentResource.reviewNoteLabels.pauseButtonTitle
	};

	return (
		<StyledLongPlayer className="StyledLongPlayer">
			<AudioPlayer {...props} />
		</StyledLongPlayer>
	);
};

export const voiceNoteShape = {
	duration: PropTypes.number,
	id: PropTypes.string.isRequired
};

export const engagementIdPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

NoteRecording.propTypes = {
	...voiceNoteShape,
	engagementId: engagementIdPropType.isRequired,
	darkMode: PropTypes.bool.isRequired,
	documentServiceURL: PropTypes.string
};

NoteRecording.defaultProps = {
	duration: 0,
	documentServiceURL: null
};

const StyledLongPlayer = styled.div`
	width: 100%;
	& > div > section,
	& > section {
		width: 100%;
	}
`;

export default NoteRecording;
